export class ResourceType{
    mediaTypeID: number;
    type: string;
    constructor(id?: number, type?: string){
        this.mediaTypeID = id;
        this.type = type;
    }
}

export class Resource{
    mediaID: number;
    directorID: number;
    name: string;
    typeID: number;
    imageData: string;
    previewURL: string;
    thumbPreviewURL: string;
    mainPreview: any;
    thumbPreview: any;
    resourceType : any;
    constructor(id?: number, dirID?: number, name?: string, typeID?: number,previewURL?: string, thumbPreviewURL?: string){
        this.mediaID = id;
        this.directorID = dirID;
        this.name = name;
        this.typeID = typeID;
        this.previewURL = previewURL;
        this.thumbPreviewURL = thumbPreviewURL;
    }

    getID(): number{
        return this.mediaID;
    }
    getDirectorID(): number{
        return this.directorID;
    }
    getName(): string{
        return this.name;
    }
    getTypeID(): number{
        return this.typeID;
    }

    setMainPreview(mp: any): void{
        this.mainPreview = mp;
    }

    getResourceType(): any{
        return this.resourceType;
    }
    setResourceType(rt :any): void{
        this.resourceType = rt;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/resource.ts